import {fromJS, Map} from 'immutable';
import gameXpActions from '../../actions/fortnite-game/gameXp.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {XpCalibrationStatus, ActivationData} from '../../types';

export interface GameXpDataItem {
    activations: ActivationData[];
    calibration: XpCalibrationStatus;
}
export interface GameXpState {
    data: GameXpDataItem;
    loading: boolean;
    error?: string;
}

export const DEFAULT_STATE = fromJS({
    data: [],
    loading: false,
    error: undefined
});

export const gameXpReducer = (state: Map<GameXpState, any> = DEFAULT_STATE, action) => {
    const {data, silent = false, error} = action.payload || {};

    switch (action.type) {
        case gameXpActions.TYPES.GET_GAME_XP: {
            return state.merge({
                error: undefined,
                loading: !silent
            });
        }

        case gameXpActions.TYPES.GET_GAME_XP_COMPLETE: {
            return state.merge({
                data,
                loading: false,
                error
            });
        }

        case gameXpActions.TYPES.GET_GAME_XP_FAILED: {
            return state.merge({
                error,
                loading: false
            });
        }

        default:
            return state;
    }
};

export default dieselReducer('gameXp', gameXpReducer);
